<template>
  <section class="triage-panel">
    <header class="triage-panel__header">
      <a-tag class="severity" :class="severityClass">
        {{ normalizedSeverity }}
      </a-tag>

      <p class="triage-panel__description">
        {{ normalizedDescription }}
      </p>
    </header>

    <div class="triage-panel__analysis">
      <div class="triage-panel__analysis-content">
        <h4 class="triage-panel__analysis-title">
          Reasons <span>({{ normalizedReasons.length }})</span>
        </h4>

        <div v-if="normalizedReasons.length" class="triage-panel__reasons" role="list">
          <div
            v-for="(reason, index) in normalizedReasons"
            :key="index"
            class="triage-panel__reason"
            role="listitem"
          >
            <span class="triage-panel__reason-number">{{ index + 1 }}</span>
            <span>{{ reason }}</span>
          </div>
        </div>
        <p v-else class="triage-panel__empty">
          N/A
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GenAiTriagePanel',
  props: {
    severity: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    reasons: {
      type: [Array, String],
      default: () => []
    }
  },
  computed: {
    normalizedSeverity() {
      return (this.severity || 'N/A').toUpperCase();
    },
    severityClass() {
      const severity = this.normalizedSeverity.toLowerCase();
      return ['high', 'medium', 'low'].includes(severity) ? severity : 'na';
    },
    normalizedDescription() {
      return this.description || 'No Description';
    },
    normalizedReasons() {
      const reasons = Array.isArray(this.reasons)
        ? this.reasons
        : String(this.reasons || '').split(/\r?\n/);

      return reasons
        .map(reason => String(reason).replace(/^\s*\d+[.)]\s*/, '').trim())
        .filter(Boolean);
    }
  }
};
</script>

<style lang="scss" scoped>
.triage-panel {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;

  &__header {
    display: grid;
    grid-template-columns: auto auto;
    gap: 10px;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
  }

  &__description {
    margin: 0;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }

  &__analysis {
    padding: 5px 16px 6px;
    border-top: 1px solid #eeeeee;
  }

  &__analysis-content {
    width: 100%;
    max-width: 140ch;
    margin: 0 auto;
  }

  &__analysis-title {
    margin: 0 0 3px;
    padding-left: 16px;
    color: #8a94a0;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.05em;
    line-height: 15px;
    text-align: left;
    text-transform: uppercase;
  }

  &__reasons {
    margin: 0;
  }

  &__reason {
    display: grid;
    grid-template-columns: 24px minmax(0, 1fr);
    gap: 8px;
    padding: 4px 0;
    line-height: 18px;

    & + & {
      border-top: 1px solid #eeeeee;
    }
  }

  &__reason-number {
    color: #8a94a0;
    font-weight: 600;
    text-align: right;
  }

  &__empty {
    margin: 0;
    color: #8a94a0;
  }

}

.severity.ant-tag {
  min-width: 48px;
  margin: 0;
  color: #ffffff;
  font-size: 10px;
  line-height: 20px;
  text-align: center;
  background-color: #a9a9a9;
  border-color: #a9a9a9;

  &.high {
    background-color: #ff5a00;
    border-color: #ff5a00;
  }

  &.medium {
    background-color: #f5c518;
    border-color: #f5c518;
  }

  &.low {
    background-color: #1e88e5;
    border-color: #1e88e5;
  }
}

@media (max-width: 767px) {
  .triage-panel {
    &__header {
      grid-template-columns: 1fr;
      gap: 9px;
      justify-items: center;
      text-align: center;
    }

  }
}
</style>
